module.exports = __webpack_public_path__ + "static/media/peach.62ab07ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/peach.png
// module id = 29
// module chunks = 0